export default {
  // Common/shared strings
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    saving: 'Saving...',
    deleting: 'Deleting...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    all: 'All',
    none: 'None',
    select: 'Select',
    required: 'Required',
    optional: 'Optional',
    actions: 'Actions',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    date: 'Date',
    time: 'Time',
    type: 'Type',
    noResults: 'No results',
    showMore: 'Show more',
    showLess: 'Show less',
  },

  // Authentication
  auth: {
    login: 'Sign in',
    logout: 'Sign out',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    newPassword: 'New password',
    currentPassword: 'Current password',
    rememberMe: 'Remember me',
    loginSubtitle: 'Sign in to continue with your tasks',
    sessionExpired: 'Session expired',
    sessionExpiredMessage: 'Please sign in again to continue.',
    loginToAccept: 'By signing in you accept our',
    termsOfService: 'terms of service',
    and: 'and',
    privacyPolicy: 'privacy policy',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    loggingIn: 'Signing in...',
    invalidCredentials: 'Invalid email or password',
    accountLocked: 'Account locked',
    passwordResetSent: 'Password reset link sent',
    passwordChanged: 'Password changed',
  },

  // Settings
  settings: {
    title: 'Settings',
    language: 'Language',
    languageFinnish: 'Suomi',
    languageEnglish: 'English',
    notifications: 'Notifications',
    emailNotifications: 'Email notifications',
    pushNotifications: 'Push notifications',
    theme: 'Theme',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    profile: 'Profile',
    account: 'Account',
    security: 'Security',
    privacy: 'Privacy',
    mySettings: 'My settings',
    changePassword: 'Change password',
    bottomNavigation: 'Bottom navigation shortcuts',
  },

  // Navigation
  nav: {
    home: 'Home',
    devices: 'Devices',
    tasks: 'Tasks',
    projects: 'Projects',
    reports: 'Reports',
    admin: 'Admin',
    settings: 'Settings',
    profile: 'Profile',
    help: 'Help',
    qms: 'QMS',
    training: 'Training',
    repairs: 'Repairs',
    hourReporting: 'Time tracking',
    diary: 'Diary',
  },

  // Devices
  devices: {
    title: 'Devices',
    device: 'Device',
    addDevice: 'Add device',
    editDevice: 'Edit device',
    deleteDevice: 'Delete device',
    deviceName: 'Device name',
    deviceType: 'Device type',
    serialNumber: 'Serial number',
    location: 'Location',
    department: 'Department',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    maintenance: 'In maintenance',
    retired: 'Retired',
    lost: 'Lost',
    lastInspection: 'Last inspection',
    nextInspection: 'Next inspection',
    manufacturer: 'Manufacturer',
    model: 'Model',
    yearOfManufacture: 'Year of manufacture',
    purchaseDate: 'Purchase date',
    warrantyExpires: 'Warranty expires',
    notes: 'Notes',
    attachments: 'Attachments',
    history: 'History',
    faults: 'Faults',
    trainings: 'Trainings',
    noDevices: 'No devices',
    searchDevices: 'Search devices...',
    filterByStatus: 'Filter by status',
    filterByType: 'Filter by type',
    filterByDepartment: 'Filter by department',
    map: 'Map',
    list: 'List',
    kanban: 'Kanban',
  },

  // Admin
  admin: {
    title: 'Admin Panel',
    users: 'Users',
    roles: 'Roles',
    trainings: 'Trainings',
    certifications: 'Certifications',
    templates: 'Templates',
    departments: 'Departments',
    announcements: 'Announcements',
    hourReporting: 'Time tracking',
    diary: 'Diary',
    qms: 'QMS',
    documents: 'Documents',
    invoicing: 'Invoicing',
    superadmin: 'Superadmin',
    settings: 'Settings',
    dashboard: 'Dashboard',
    tasks: 'Tasks',
    infoTV: 'InfoTV',
    cards: 'Cards',
  },

  // Users
  users: {
    title: 'Users',
    user: 'User',
    addUser: 'Add user',
    editUser: 'Edit user',
    deleteUser: 'Delete user',
    email: 'Email',
    name: 'Name',
    role: 'Role',
    department: 'Department',
    jobRole: 'Job role',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    lastLogin: 'Last login',
    createdAt: 'Created',
    noUsers: 'No users',
    searchUsers: 'Search users...',
    inviteUser: 'Invite user',
    resendInvite: 'Resend invite',
    actions: 'Actions',
    cards: 'Cards',
  },

  // Roles & Permissions
  roles: {
    title: 'Roles',
    role: 'Role',
    addRole: 'Add role',
    editRole: 'Edit role',
    deleteRole: 'Delete role',
    roleName: 'Role name',
    permissions: 'Permissions',
    description: 'Description',
    admin: 'Admin',
    user: 'User',
    viewer: 'Viewer',
    noRoles: 'No roles',
  },

  // Trainings
  trainings: {
    title: 'Trainings',
    training: 'Training',
    addTraining: 'Add training',
    editTraining: 'Edit training',
    deleteTraining: 'Delete training',
    trainingName: 'Training name',
    validityPeriod: 'Validity period',
    months: 'months',
    required: 'Required',
    optional: 'Optional',
    completed: 'Completed',
    expired: 'Expired',
    expiring: 'Expiring',
    valid: 'Valid',
    noTrainings: 'No trainings',
    completeTraining: 'Complete training',
    renewTraining: 'Renew training',
    certificate: 'Certificate',
  },

  // QMS (Quality Management System)
  qms: {
    title: 'Quality Management',
    nonconformance: 'Nonconformance',
    nonconformances: 'Nonconformances',
    addNonconformance: 'Add nonconformance',
    risk: 'Risk',
    risks: 'Risks',
    document: 'Document',
    documents: 'Documents',
    audit: 'Audit',
    audits: 'Audits',
    corrective: 'Corrective action',
    preventive: 'Preventive action',
    status: 'Status',
    open: 'Open',
    inProgress: 'In progress',
    closed: 'Closed',
    severity: 'Severity',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    critical: 'Critical',
  },

  // Hour Reporting
  hours: {
    title: 'Time tracking',
    addEntry: 'Add entry',
    date: 'Date',
    hours: 'Hours',
    project: 'Project',
    task: 'Task',
    description: 'Description',
    totalHours: 'Total hours',
    thisWeek: 'This week',
    thisMonth: 'This month',
    approve: 'Approve',
    reject: 'Reject',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
  },

  // Projects & Tasks
  projects: {
    title: 'Projects',
    project: 'Project',
    addProject: 'Add project',
    editProject: 'Edit project',
    task: 'Task',
    tasks: 'Tasks',
    addTask: 'Add task',
    assignee: 'Assignee',
    dueDate: 'Due date',
    priority: 'Priority',
    low: 'Low',
    medium: 'Normal',
    high: 'High',
    urgent: 'Urgent',
    status: 'Status',
    todo: 'To do',
    inProgress: 'In progress',
    done: 'Done',
  },

  // Reports
  reports: {
    title: 'Reports',
    generate: 'Generate report',
    export: 'Export',
    exportExcel: 'Export Excel',
    exportPDF: 'Export PDF',
    dateRange: 'Date range',
    from: 'From',
    to: 'To',
    today: 'Today',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisYear: 'This year',
    custom: 'Custom',
  },

  // Errors
  errors: {
    generic: 'An error occurred',
    networkError: 'Network error',
    notFound: 'Not found',
    unauthorized: 'Unauthorized',
    forbidden: 'Access denied',
    serverError: 'Server error',
    validationError: 'Please check your input',
    requiredField: 'Required field',
    invalidEmail: 'Invalid email',
    invalidPhone: 'Invalid phone number',
    passwordTooShort: 'Password is too short',
    passwordsDoNotMatch: 'Passwords do not match',
    tryAgain: 'Try again',
    contactSupport: 'Contact support',
  },

  // Confirmations
  confirm: {
    delete: 'Are you sure you want to delete?',
    deleteItem: 'Are you sure you want to delete "{name}"?',
    unsavedChanges: 'You have unsaved changes. Do you want to leave?',
    logout: 'Do you want to sign out?',
    irreversible: 'This action cannot be undone.',
  },

  // Time & Dates
  time: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    now: 'Now',
    ago: 'ago',
    in: 'in',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    weeks: 'weeks',
    months: 'months',
    years: 'years',
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    noNotifications: 'No notifications',
    newNotification: 'New notification',
  },

  // File handling
  files: {
    upload: 'Upload file',
    download: 'Download',
    delete: 'Delete file',
    preview: 'Preview',
    noFiles: 'No files',
    dragAndDrop: 'Drag and drop files here',
    orClickToUpload: 'or click to select',
    maxSize: 'Max size',
    allowedTypes: 'Allowed types',
    uploadError: 'Upload failed',
    uploadSuccess: 'Upload successful',
  },
};
